import "esbuild-css-modules-plugin-ns-css:src/lib/gantt-task-react/src/components/task-item/milestone/milestone.module.css";

export default {
  "milestoneBackground": "milestone-module__milestoneBackground_TSlJZa__100",
  "milestoneWrapper": "milestone-module__milestoneWrapper_TSlJZa__100"
};
      